import React from 'react'

export type NavIconId = 'home' | 'bet' | 'control' | 'games' | 'promo'

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true as const,
  focusable: false as const,
}

function HomeIcon() {
  return (
    <svg {...svgProps}>
      <path
        d="M4.5 10.8 12 4.5l7.5 6.3V19a1.5 1.5 0 0 1-1.5 1.5h-3.75V14.25h-4.5V20.5H6A1.5 1.5 0 0 1 4.5 19v-8.2Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        fill="currentColor"
        fillOpacity="0.18"
      />
    </svg>
  )
}

function BetIcon() {
  return (
    <svg {...svgProps}>
      <rect
        x="4"
        y="5.5"
        width="16"
        height="13"
        rx="2.2"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="currentColor"
        fillOpacity="0.14"
      />
      <path
        d="M8 9.5h8M8 12.5h5.5M8 15.5h6.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="17.2" cy="8.2" r="1.1" fill="currentColor" />
    </svg>
  )
}

function ControlIcon() {
  return (
    <svg {...svgProps}>
      <rect
        x="3.5"
        y="3.5"
        width="7.5"
        height="7.5"
        rx="1.8"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <rect
        x="13"
        y="3.5"
        width="7.5"
        height="4.5"
        rx="1.6"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <rect
        x="13"
        y="10.5"
        width="7.5"
        height="10"
        rx="1.8"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <rect
        x="3.5"
        y="13.5"
        width="7.5"
        height="7"
        rx="1.8"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
    </svg>
  )
}

function GamesIcon() {
  return (
    <svg {...svgProps}>
      <rect
        x="3.5"
        y="7.5"
        width="17"
        height="11"
        rx="3.2"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <path
        d="M8.2 13h3.2M9.8 11.4v3.2"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="15.2" cy="11.8" r="1.05" fill="currentColor" />
      <circle cx="17.6" cy="14.2" r="1.05" fill="currentColor" />
    </svg>
  )
}

function PromoIcon() {
  return (
    <svg {...svgProps}>
      <path
        d="M8.2 20.2 4.8 16.8a2.2 2.2 0 0 1 0-3.1l8.5-8.5a2.2 2.2 0 0 1 3.1 0L19.8 8a2.2 2.2 0 0 1 0 3.1l-8.5 8.5a2.2 2.2 0 0 1-3.1 0Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <circle cx="15.35" cy="8.65" r="1.25" fill="currentColor" />
      <path
        d="M8.8 14.2h3.4M10 15.8v-3.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

const ICONS: Record<NavIconId, React.FC> = {
  home: HomeIcon,
  bet: BetIcon,
  control: ControlIcon,
  games: GamesIcon,
  promo: PromoIcon,
}

interface HtGoldBottomNavIconProps {
  id: NavIconId
  raised?: boolean
}

export function HtGoldBottomNavIcon({ id, raised = false }: HtGoldBottomNavIconProps) {
  const Icon = ICONS[id] ?? HomeIcon
  return (
    <span className={`htg-dock__svg${raised ? ' is-raised' : ''}`} data-nav-id={id}>
      <Icon />
    </span>
  )
}
